import React from "react";
import { BulletPointSalesBox } from "../BulletPointSalesBox/BulletPointSalesBox.jsx";
import { DiscountBadge } from "@obby/components";
import { Box, ImageTag } from "./ImageTextListBanner.layout";

export function ImageTextListBanner({
  color,
  reverse,
  containerMargin,
  imageFullWidth,
  image,
  imageClassName,
  title,
  discount,
  description,
  points,
  size,
  children,
  border,
  css,
  textCss,
  imgCss,
  bulletPointTitleCss
}) {
  return (
    <Box
      componentname="image-text-list-banner"
      css={{
        backgroundColor: color ? `$${color}` : "$white",
        margin: `${containerMargin || 0}px 0px`,
        ...css
      }}
      border={border}
      variant="banner"
      reverse={reverse}
    >
      {imageFullWidth && (
        <Box
          variant="imageWrap"
          imageWrapFull
          componentname="image-text-list-banner__image-wrap"
          className="image-text-list-banner__image-wrap"
          style={{ backgroundImage: `url(${image})` }}
        ></Box>
      )}
      {!imageFullWidth && (
        <Box
          variant="imageWrap"
          componentname="image-text-list-banner__image-wrap"
          className="image-text-list-banner__image-wrap"
        >
          <ImageTag
            variant="image"
            typeOfBanner={imageClassName}
            componentname="image-text-list-banner__image"
            className="image-text-list-banner__image"
            alt={title}
            src={image}
            css={imgCss}
          />
        </Box>
      )}

      <Box
        variant="text"
        css={textCss}
        componentname="image-text-list-banner__text"
        className="image-text-list-banner__text"
      >
        <Box
          variant="wrapper"
          componentname="image-text-list-banner__wrapper"
          className="image-text-list-banner__wrapper"
        >
          {discount && (
            <DiscountBadge
              value={discount.value}
              type={discount.type}
              rotate={-25}
            />
          )}

          <BulletPointSalesBox
            title={title}
            description={description}
            points={points}
            size={size}
            titleCss={bulletPointTitleCss}
          />
          {children && (
            <Box className="image-text-list-banner__children">{children}</Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
